export default __webpack_public_path__ + "static/media/050_brake.first.c9076def.avif";